import { render, staticRenderFns } from "./VoteStub.vue?vue&type=template&id=6c36fbb1&scoped=true&"
import script from "./VoteStub.vue?vue&type=script&lang=js&"
export * from "./VoteStub.vue?vue&type=script&lang=js&"
import style0 from "./VoteStub.vue?vue&type=style&index=0&id=6c36fbb1&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c36fbb1",
  null
  
)

export default component.exports